<template>
  <div>
    <v-data-table
        dense
        :headers="columns"
        :items="getRowList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        v-model="selectedItemList"
        :footer-props="{
          'items-per-page-options': [20, 50, 100]
        }"
        :height="$vuetify.breakpoint.height - 180"
        fixed-header
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-text-field
              dark
              v-model="searchTermFile"
              label="Content search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-spacer></v-spacer>
          <StoreDocDialog
              buttonText="Add document"
              title="Add document"
              :isNewItem="true"
              v-model="newItem"
              @change="onNewItem"
          >
          </StoreDocDialog>
        </v-toolbar>
      </template>
      <template v-slot:item.title="{ item }">
        <router-link :to="{name: 'StoreDocItem', params: {storeDocItemId: item.id, searchTermFile: searchTermFile}}">
          {{ item.title }}
        </router-link>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-container fluid>
          <v-row>
<!--            <v-icon-->
<!--                color="primary"-->
<!--                small-->
<!--                @click="onEdit(item.id)"-->
<!--            >-->
<!--              mdi-pencil-->
<!--            </v-icon>-->
            <BaseDeleteDialog :loading="deleteLoading" :item="item" :onDeleteAction="onDeleteRow"></BaseDeleteDialog>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.description="{ item }">
        <span v-if="item.description === null">
        </span>
        <span v-else-if="item.description.length > 200">
          {{ item.description.slice(0, 200) }}...
        </span>
        <span v-else>
          {{ item.description }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import StoreDocDialog from "@/components/StoreDoc/StoreDocDialog";
import StoreDocItem from "@/components/StoreDoc/StoreDocItem";

export default {
  name: 'StoreDocList',

  components: {
    BaseDeleteDialog,
    StoreDocDialog,
    StoreDocItem,
  },

  computed: {
    ...mapGetters('StoreDocList', ['getRowList']),
    ...mapFields('StoreDocList', ['editedItem', 'itemList', 'saveLoading', 'addLoading', 'options',
      'options.rowsPerPageItems', 'options.sortBy', 'totalRecords',
      'loading', 'deleteLoading', 'previewLink', 'selectedItemList', 'searchTermFile', 'searchTerm']),
  },

  methods: {
    ...mapActions('StoreDocList', ['fetchItemList', 'fetchDeleteRow', 'fetchSaveItem', 'fetchAddItem']),
    onUpdateSearchTerm() {
      // this.$store.commit('StoreDocList/updateSearchTerm', this.searchTerm)
      this.fetchItemList();
    },
    updateOptions() {
      this.fetchItemList()
    },

    onDeleteRow(item) {
      // console.log('onDeleteRow')
      console.log(item)
      this.fetchDeleteRow(item);
    },
    // onEdit(itemId) {
    //   // console.log(itemId)
    //   this.$router.push({name: 'StoreDocItem', params: {storeDocItemId: itemId, searchTermFile: this.searchTermFile}})
    // },
    onNewItem(item) {
      this.itemList.push(item)
    }
  },

  async mounted() {
    await this.fetchItemList();
  },

  data() {
    return {
      // searchTerm: null,
      newDialog: false,
      dialogDelete: false,
      newItem: {},
      columns: [
        {text: '', value: 'actions', sortable: false, divider: true, width: 70},
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true,},
        {text: 'Model', value: 'child_model', sortable: false, filterable: true, divider: true,},
        {text: 'Description', value: 'description', sortable: false, divider: true},
        // {text: 'File', value: 'file', sortable: false, divider: true},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.preview-iframe {
  width: 100%;
  height: 90%;
}
</style>
